import React from 'react';
type Props = {
  tone?: 'light' | 'dark';
};

/** Official KAYS & KAYS icon and wordmark (white on transparent) — used as masks so they take the current text colour. */
export const MARK_SRC = 'https://cdn.magicpatterns.com/uploads/akb6ywgJ2hd9NmfVDTFi3X/KK_M01_Logo_Icon_White.svg';
export const WORDMARK_SRC = 'https://cdn.magicpatterns.com/uploads/iBB7pZ7H4MXWmo1cGq3xiW/KK_M01_Logo_Wordmark_White.svg';
export function Logo({
  tone = 'light'
}: Props) {
  const text = tone === 'light' ? 'text-cream' : 'text-ink';
  return <a href="/" className={`inline-flex items-center gap-2.5 transition-colors duration-300 ${text}`} aria-label="Kays&Kays home" data-id="element-295" data-mp="rqmf4ro1x7eb">
      <MaskedArt src={MARK_SRC} className="h-7 w-7 md:h-[30px] md:w-[30px]" data-id="element-296" data-mp="hthuwxdrnm05" />
      <MaskedArt src={WORDMARK_SRC} className="aspect-[1920/492] h-[30px] opacity-90 md:h-[34px]" data-id="element-297" data-mp="hvm8k71gvzdm" />
    </a>;
}

/** Paints a white-on-transparent SVG in the current text colour, with no background box. */
export function MaskedArt({
  src,
  className = ''
}: {
  src: string;
  className?: string;
}) {
  const mask = `url("${src}")`;
  return <span aria-hidden="true" className={`block shrink-0 bg-current ${className}`} style={{
    WebkitMaskImage: mask,
    maskImage: mask,
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center'
  }} data-id="element-298" data-mp="19wq6nji9iwb1" />;
}